/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popExtraInvite.vue?vue&type=template&id=8cb828b8&scoped=true"
import script from "./popExtraInvite.vue?vue&type=script&lang=js"
export * from "./popExtraInvite.vue?vue&type=script&lang=js"
import style0 from "./popExtraInvite.vue?vue&type=style&index=0&id=8cb828b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb828b8",
  null
  
)

export default component.exports